module.exports = __webpack_public_path__ + "static/media/team_morale_survey_response.0a5d8fdf.png";